interface SkipLinkProps {
  targetId?: string;
  children?: React.ReactNode;
}

const SkipLink = ({ targetId = 'main-content', children = 'Skip to main content' }: SkipLinkProps): React.JSX.Element => (
  <a
    href={`#${targetId}`}
    className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[9999] focus:px-4 focus:py-2 focus:bg-white focus:text-blue-700 focus:rounded-md focus:shadow-lg focus:outline-2 focus:outline-offset-2 focus:outline-blue-500"
  >
    {children}
  </a>
);

export default SkipLink;
